import { createContext, useContext, useEffect, useState, type ReactNode } from 'react';
import { APP_LOGO_FALLBACK } from '@/constants/branding';
import { fetchMainAppLoginLogo } from '@/utils/mainAppAssets';

const LogoContext = createContext(APP_LOGO_FALLBACK);

export function LogoProvider({ children }: { children: ReactNode }) {
  const [logoSrc, setLogoSrc] = useState(APP_LOGO_FALLBACK);

  useEffect(() => {
    let cancelled = false;
    fetchMainAppLoginLogo()
      .then((url) => {
        if (!cancelled && url) setLogoSrc(url);
      })
      .catch(() => {
        /* keep fallback */
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return <LogoContext.Provider value={logoSrc}>{children}</LogoContext.Provider>;
}

export function useAppLogo(): string {
  return useContext(LogoContext);
}
